exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3qa8OvFCuxvXSKgE8anB8n{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.RP2pH1uXoKzUKSJFNIvO{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;height:48px;width:100%}html[dir] .RP2pH1uXoKzUKSJFNIvO{background:transparent}html[dir=ltr] ._2YSlgSzE5AomO_8RSnEjNq{text-align:left;margin-left:10px}html[dir=rtl] ._2YSlgSzE5AomO_8RSnEjNq{text-align:right;margin-right:10px}", ""]);
// Exports
exports.locals = {
	"horizontalContainer": "_3qa8OvFCuxvXSKgE8anB8n",
	"buttonRoot": "RP2pH1uXoKzUKSJFNIvO",
	"buttonTextContainer": "_2YSlgSzE5AomO_8RSnEjNq"
};